import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IMissionResource } from "../types";

export type IMissionUpdateMutationParameters = {
    mission: RelationalValue<IMissionResource>;
    title: string;
    periodStart: string;
    periodEnd: string;
    waypoint: string;
    context: string;
    description: string;
    skills: string[];
    learners: string[];
};

export type IMissionUpdateMutationResult = IMissionResource;

export const missionUpdateMutation: IApiMutationFunction<IMissionUpdateMutationParameters> = ({
    mission,
    title,
    periodStart,
    periodEnd,
    waypoint,
    context,
    description,
    skills,
    learners,
}) => {
    return {
        method: "PUT",
        url: `/missions/${mapRelationalValue(mission)}`,
        data: {
            title,
            periodStart,
            periodEnd,
            waypoint,
            context,
            description,
            skills,
            learners,
        },
    };
};

export const useMissionUpdateMutation = createApiMutationHook<
    IMissionUpdateMutationParameters,
    IMissionUpdateMutationResult
>(missionUpdateMutation);
